import { createRouter, createWebHashHistory } from "vue-router";

import { setRouter } from "@/router";

import { assertLoggedIn } from "./guards/assertLoggedIn";
import { setDocTitle } from "./guards/docTitle";
import { handleNonSessionParams } from "./guards/handleNonSessionParams";
import { handleSessionParam } from "./guards/handleSessionParam";
import { logError } from "./guards/logError";
import { routes } from "./routes";
import { addSyncNav } from "./syncNav";

export const router = addSyncNav(createRouter({ history: createWebHashHistory(), routes }));

router.beforeEach(assertLoggedIn);
router.beforeEach(handleSessionParam);
router.beforeEach(handleNonSessionParams);
router.afterEach(setDocTitle);
router.onError(logError);

setRouter(router);
